import React from "react";
import { Outlet } from "react-router-dom";
import { Event } from "@uno/protocol";
import { AppContext } from "context";
import useStorePlayer from "store/useStorePlayer";
import Sound from "../Sound/Sound";
import Toast from "../Toast";
import useSocketRedirect from "hook/useSocketRedirect";

function Layout() {
    const { socket } = React.useContext(AppContext);
    const setPlayer = useStorePlayer((state) => state.setPlayer);
    useSocketRedirect(socket);

    React.useEffect(() => {
        socket?.on(Event.PlayerStateUpdate, setPlayer);

        return () => {
            socket?.off(Event.PlayerStateUpdate, setPlayer);
        };
    }, [socket, setPlayer]);

    return (
        <>
            <Sound />
            <Toast />
            <Outlet />
        </>
    );
}

export default Layout;
